module.exports = __webpack_public_path__ + "media/images/icons/material/pencil-0ae457214cafea26961e5b4c06ad0de8.svg";